import { render, staticRenderFns } from "./cms-component-social-links.vue?vue&type=template&id=1a303a4a&scoped=true"
import script from "./cms-component-social-links.vue?vue&type=script&lang=js"
export * from "./cms-component-social-links.vue?vue&type=script&lang=js"
import style0 from "./cms-component-social-links.vue?vue&type=style&index=0&id=1a303a4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a303a4a",
  null
  
)

export default component.exports